<template lang="pug">
  product-listings-layout(:sortVisible="products")
    h1(slot="title") {{ title }}

    //- (left col)
    aside.text-17.hidden.md-block(slot="leftcol")
      //- groups...
      template(v-for="section in ['Shop', 'Makers']")
        h6.text-13.mb-10 {{ section }}
        ul.mb-40
          //- categories
          template(v-if="section === 'Shop'")
            li.mb-2(v-for="cat in categories")
              router-link.hover-text-app-text(:to="{name: 'products_collection', params: {collection: cat.base_shopify_collection.post_name}}", :class="{'text-app-accent': $route.params.collection === cat.base_shopify_collection.post_name}")
                | {{cat.base_shopify_collection.post_title}}

          //- makers
          template(v-if="section === 'Makers'")
            li.mb-2(v-for="mkr in makersLinks")
              router-link.hover-text-app-text(:to="{name: 'products_collection', params: {collection: mkr.link.post_name}}", :class="{'text-app-accent': $route.params.collection === mkr.link.post_name}")
                | {{mkr.link.post_title}}

    //- results
    products-results(:products="products", :hasNextPage="nextCursor", @more="get({after: nextCursor, append: true})")
    //- next page for SEO bots
    router-link.hidden(:to="{query: {after: nextCursor}}", rel="noindex") Next Page
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ProductListingsLayout from '@/components/Shop/ProductListingsLayout'
import ProductsResults from '@/components/Shop/ProductsResults'
export default {
  name: 'Products__Index',
  data () {
    return {
      title: 'All Products',
      products: null,
      nextCursor: null,
      apiQuery: ''
    }
  },
  computed: {
    ...mapState({
      querying: state => state.shop.querying,
      sort: state => state.shop.sort,
      categories: state => state.site ? state.site.categories_menu : [],
      makersLinks: state => state.site ? state.site.makers_links : []
    })
  },
  methods: {
    ...mapMutations({ setQuerying: 'shop/setQuerying' }),
    async get ({ after, append }) {
      if (this.querying) return

      // is new query?
      if (!append) {
        this.apiQuery = ''
        this.products = null
      }

      // go
      try {
        const params = { after }

        // sort by recommended ?
        if (this.sort === 'recommended' && !this.apiQuery.includes('recommended')) {
          this.apiQuery = 'tag:recommended'
        }
        // attach query
        params.query = this.apiQuery // "tag:recommended AND vendor:"Blue Mounain School" OR vendor:"...""

        // query !
        this.setQuerying(true)
        const resp = await this.$store.dispatch('shop/getProducts', params)

        // process
        const prdcts = resp.edges.map(itm => itm.node)
        const isRecd = this.apiQuery.startsWith('tag:recommended')
        this.nextCursor = this.getNextCursor(resp)

        // save
        this.products = append && this.products ? this.products.concat(prdcts) // append to current result
          : isRecd && !prdcts.length && !this.nextCursor ? null // skip to non-rec'd query (so doesn't show "No Results")
            : prdcts
        this.setQuerying(false)

        // if end of recommended query, continue into "non-recommended" query...
        if (isRecd && !this.nextCursor) {
          this.apiQuery = '-tag:recommended'
          return this.get({ append: true })
        }
      } catch (e) {
        console.error(e)
        this.setQuerying(false)
      }
    },

    getNextCursor (resp) {
      // get cursor of last product (edge) from API resp
      if (resp && resp.pageInfo.hasNextPage) {
        return resp.edges[resp.edges.length - 1].cursor
      }
      return null
    }
  },
  watch: {
    sort () {
      // when sort changes, re-query...
      this.get({})
    }
  },
  created () {
    // this.$emit('products', null)
    this.get({ after: this.$route.query.after }) // will capture `after` for SEO / pagination
  },
  metaInfo () {
    return {
      title: 'Hostem - ' + this.title,
      meta: [
        { name: 'robots', content: 'noindex, nofollow' }
      ],
      links: [
        { rel: 'canonical', href: process.env.VUE_APP_CANONICAL_DOMAIN + '/hostem/products' }
      ]
    }
  },
  components: { ProductListingsLayout, ProductsResults }
}
</script>

<style>
</style>
